// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  standalone: true,
  imports: [TranslateModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  selector: 'app-dna-syngovia-chart-map-legend',
  templateUrl: './dna-syngovia-chart-map-legend.component.html',
  styleUrl: './dna-syngovia-chart-map-legend.component.scss',
})
export class DnaSyngoviaChartMapLegendComponent {}
